import { FC, useState } from 'preact/compat'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import SearchLogo from '../../../../../../../themes/custom/toybox/src/images/search--currentcolor.svg'
import X from '../../../../../../../themes/custom/toybox/src/images/x.svg'
import { RaffleSearchInput } from './raffle-search-input'
import { MotionNodeAnimationOptions } from 'motion'
// Using react-m for reduced bundle size by excluding unused features.
// https://motion.dev/docs/react-reduce-bundle-size#reduce-size
import * as m from 'motion/react-m'
import { AnimatePresence } from 'motion/react'
import { TopQuestionsList } from './top-questions-list'

export type SearchDialogProps = {
  searchPageUrl: string
  raffleSearchUid: string
}

export const SearchDialog: FC<SearchDialogProps> = ({
  searchPageUrl,
  raffleSearchUid,
}: SearchDialogProps) => {
  const title = 'Find svar'

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const dialogAnimation: MotionNodeAnimationOptions = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: 'easeInOut',
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: 'easeInOut',
      },
    },
  }

  const dialogPanelAnimation: MotionNodeAnimationOptions = {
    transition: {
      type: 'spring',
      duration: 0.5,
      bounce: 0.45,
      delay: 0.4,
    },
    initial: {
      opacity: 0,
      scale: 0.9,
    },
    animate: {
      opacity: 1,
      scale: 1,
    },
    exit: {
      opacity: 0,
      scale: 0.9,
      transition: {
        delay: 0,
      },
    },
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="raffle-search-dialog__trigger typo__bordeaux-color header__tool-link header__tool-link--low-priority"
      >
        <SearchLogo aria-hidden />
        Søg
      </button>
      <AnimatePresence>
        {isOpen && (
          <Dialog
            static // Always render to support motion exit animation.
            open={isOpen}
            onClose={() => setIsOpen(false)}
          >
            <m.div
              className="raffle-search-dialog typo__light-text"
              {...dialogAnimation}
            >
              <DialogPanel className="raffle-search-dialog__panel">
                <m.div {...dialogPanelAnimation}>
                  <div className="layout__unit raffle-search-dialog__top-panel">
                    <h2 className="raffle-search-dialog__title raffle-search-dialog__title--mobile">
                      {title}
                    </h2>
                    <button
                      className="raffle-search-dialog__close"
                      onClick={() => setIsOpen(false)}
                      aria-label="Luk"
                    >
                      <X aria-hidden />
                    </button>
                  </div>
                  <div className="raffle-search-dialog__content layout__unit layout__unit--max-width-wide">
                    <div>
                      {/* Names the dialog. The mobile title repeats it. */}
                      <DialogTitle
                        as="h2"
                        className="raffle-search-dialog__title raffle-search-dialog__title--desktop"
                      >
                        {title}
                      </DialogTitle>
                      <form
                        action={searchPageUrl}
                        class="typo__margin-top--small typo__no-margin--bottom"
                      >
                        <RaffleSearchInput data-autofocus />
                      </form>
                    </div>

                    <TopQuestionsList
                      raffleSearchUid={raffleSearchUid}
                      searchPageUrl={searchPageUrl}
                    />

                    <h3 className="sr-only">Kontaktinformation</h3>
                    <p className="raffle-search-dialog__info">
                      <strong>Har du brug for at tale med os?</strong>
                      <br />
                      <a href="tel:+4535465000">Ring 35 46 50 00</a>
                    </p>
                  </div>
                </m.div>
              </DialogPanel>
            </m.div>
          </Dialog>
        )}
      </AnimatePresence>
    </>
  )
}
